import React from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const PhoneNumberFormat = ({ number, type = "international" }) => {
  if (!number) return null;

  try {
    const phoneObj = parsePhoneNumberFromString(number);

    if (!phoneObj) return number;

    if (type === "national") {
      // Local format (without country code)
      return phoneObj.formatNational();
    }

    // Default: International format
    return phoneObj.formatInternational();
  } catch {
    return number;
  }
};

export default PhoneNumberFormat;
